export * from './src/card-accordion.component';
